import { Box, Container, Typography, Button } from '@mui/material';
import { ArrowRight } from 'lucide-react';

export function CallToAction({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const cta = data.cta;

  if (!cta || (!cta.title && !cta.subtitle)) return null;

  const title = cta.title;
  const subtitle = cta.subtitle;
  const buttonText = cta.button_text || 'Apply Online Now';

  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: primaryColor,
        color: '#ffffff',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        {title && (
          <Typography
            variant="h2"
            fontWeight={900}
            sx={{
              fontSize: { xs: '2.25rem', md: '3.25rem' },
              letterSpacing: '-0.02em',
              mb: 2,
            }}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            variant="h6"
            sx={{
              opacity: 0.9,
              fontWeight: 400,
              fontSize: { xs: '1rem', md: '1.25rem' },
              mb: 4,
              maxWidth: 600,
              mx: 'auto',
            }}
          >
            {subtitle}
          </Typography>
        )}

        <Button
          component="a"
          href="#contact"
          variant="contained"
          size="large"
          endIcon={<ArrowRight size={20} />}
          sx={{
            backgroundColor: '#ffffff',
            color: primaryColor,
            fontWeight: 800,
            px: 4,
            py: 1.6,
            borderRadius: 3,
            fontSize: '1.05rem',
            textTransform: 'none',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.25)',
            '&:hover': {
              backgroundColor: '#f8fafc',
              transform: 'translateY(-2px)',
            },
          }}
        >
          {buttonText}
        </Button>
      </Container>
    </Box>
  );
}

export default CallToAction;
